import React, { useState } from 'react';
import './InterestsPopup.css';

interface InterestsPopupProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (interests: string[]) => void;
}

const InterestsPopup: React.FC<InterestsPopupProps> = ({ isOpen, onClose, onSubmit }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedInterests, setSelectedInterests] = useState<string[]>([]);

  const categories = [
    { id: '1', name: 'English', icon: '🇬🇧' },
    { id: '2', name: 'Math', icon: '🔢' },
    { id: '3', name: 'Science', icon: '🔬' },
    { id: '4', name: 'History', icon: '📜' },
    { id: '5', name: 'Art', icon: '🎨' },
    { id: '6', name: 'Spanish', icon: '🇪🇸' },
    { id: '7', name: 'Computer Science', icon: '💻' },
    { id: '8', name: 'Business', icon: '💼' },
    { id: '9', name: 'Music', icon: '🎵' },
    { id: '10', name: 'Sports', icon: '⚽' },
    { id: '11', name: 'Photography', icon: '📷' },
    { id: '12', name: 'Cooking', icon: '👨‍🍳' }
  ];

  const filteredCategories = categories.filter(category =>
    category.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const toggleInterest = (categoryId: string) => {
    setSelectedInterests(prev =>
      prev.includes(categoryId)
        ? prev.filter(id => id !== categoryId)
        : [...prev, categoryId]
    );
  };

  const handleSubmit = () => {
    if (selectedInterests.length > 0) {
      onSubmit(selectedInterests);
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="interests-popup-overlay" onClick={onClose}>
      <div className="interests-popup" onClick={(e) => e.stopPropagation()}>
        <button className="popup-close" onClick={onClose}>✕</button>
        
        <div className="popup-header">
          <div className="popup-icon">🎯</div>
          <h2 className="popup-title">أخبرنا اهتماماتك</h2>
          <p className="popup-subtitle">اختر المجالات التي تهمك لنساعدك في العثور على المحتوى المناسب</p>
        </div>

        <div className="search-container">
          <span className="search-icon">🔍</span>
          <input
            type="text"
            placeholder="ابحث عن المجالات..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search-input"
          />
        </div>

        <div className="categories-grid">
          {filteredCategories.map((category) => (
            <div
              key={category.id}
              className={`category-card ${selectedInterests.includes(category.id) ? 'selected' : ''}`}
              onClick={() => toggleInterest(category.id)}
            >
              <input
                type="checkbox"
                checked={selectedInterests.includes(category.id)}
                onChange={() => toggleInterest(category.id)}
                className="category-checkbox"
              />
              <div className="category-icon">{category.icon}</div>
              <span className="category-name">{category.name}</span>
            </div>
          ))}
        </div>

        <div className="popup-footer">
          <button
            className={`submit-interests-button ${selectedInterests.length > 0 ? 'active' : ''}`}
            onClick={handleSubmit}
            disabled={selectedInterests.length === 0}
          >
            متابعة ({selectedInterests.length})
          </button>
        </div>
      </div>
    </div>
  );
};

export default InterestsPopup;

